// @flow

import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Navigation from './Navigation';
import Loadable from '../components/Loadable';
import Preload from './PreloadScreen';
import typeof TTheme from '../theme';
import ReactGA from 'react-ga';

// GOOGLE ANALYTICS: INITIALIZE
ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
// GOOGLE ANALYTICS: TRACK SCREENS [history, members, profile, signup, welcome]
class Analytics extends Component<RouteComponentProps<any>> {
  componentDidMount() {
    this.sendPageChange(this.props.location.pathname);
  }
  componentDidUpdate(prevProps: RouteComponentProps<any>) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.sendPageChange(this.props.location.pathname);
    }
  }
  sendPageChange(pathname: string) {
    ReactGA.set({ pathname });
    ReactGA.pageview(pathname);
  }
  render() {
    return null;
  }
}

const AnalyticsTracker = () => {
  return <Route component={Analytics} />;
};

const History = Loadable({
  loader: () => import(/* webpackChunkName: "app-history" */ './History'),
  loading: Preload,
});

const Profile = Loadable({
  loader: () => import(/* webpackChunkName: "app-profile" */ './Profile'),
  loading: Preload,
});

const Members = Loadable({
  loader: () => import(/* webpackChunkName: "app-members" */ './Members'),
  loading: Preload,
});

const Billing = Loadable({
  loader: () => import(/* webpackChunkName: "app-billing" */ './Billing'),
  loading: Preload,
});

const Logout = Loadable({
  loader: () => import(/* webpackChunkName: "app-logout" */ './Logout'),
  loading: Preload,
});

const ActivePage = () => (
  <Switch>
    <Route exact path="/logout" component={Logout} />
    <Route exact path="/history" component={History} />
    <Route exact path="/profile" component={Profile} />
    <Route exact path="/members" component={Members} />
    <Route exact path="/billing" component={Billing} />
    {/* No 404s, just drop back to history for now */}
    <Redirect to="/history" />
  </Switch>
);

type TP = { theme: TTheme };

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  @media ${({ theme }: TP) => theme.mediaQueries.small} {
    flex-direction: column;
  }
`;

const NavigationContainer = styled(Navigation)`
  background: ${({ theme }: TP) => theme.colors.secondary};
  padding: 45px 20px 36px;
  width: 240px;
  @media ${({ theme }: TP) => theme.mediaQueries.small} {
    width: 100%;
    padding: 0 0.5em;
  }
`;

const PageContainer = styled.div`
  flex: 1;
  height: inherit;
  overflow-y: scroll;
`;

const Layout = () => (
  <Container>
    <AnalyticsTracker />
    <NavigationContainer />
    <PageContainer>
      <Switch>
        <Route path="/:id" component={ActivePage} />
        <Redirect exact from="/" to="/history" />
      </Switch>
    </PageContainer>
  </Container>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/App/Root.js